import React from 'react';
import { Navigate } from 'react-router-dom';

import AppShell from 'shared/AppShell/AppShell';
import RequireAuth from 'components/RequireAuth';
import PageNotFound from 'components/PageNotFound';
import Login from 'containers/Login/Login';

import { UploadsPage } from 'features/uploads';
import { PackagesPage } from 'features/packages';
import { CouponsListPage, CreateCouponPage, EditCouponPage, ViewCouponPage } from 'features/coupons';

import paths from './paths';
import { legacyUploadRedirects } from './legacyRedirects';

const publicRoutes = [
  { path: paths.root, element: <Navigate to={paths.login} replace /> },
  { path: paths.login, element: <Login /> },
];

const protectedRoutes = [
  { path: paths.homePage, element: <Navigate to={paths.coupons.list} replace /> },
  { path: paths.packages, element: <PackagesPage /> },
  { path: paths.uploads, element: <UploadsPage /> },
  { path: paths.coupons.list, element: <CouponsListPage /> },
  { path: paths.coupons.create, element: <CreateCouponPage /> },
  { path: paths.coupons.edit(':id'), element: <EditCouponPage /> },
  { path: paths.coupons.view(':id'), element: <ViewCouponPage /> },
  ...legacyUploadRedirects,
  { path: '*', element: <PageNotFound /> },
];

const routeConfig = [
  {
    element: <AppShell />,
    children: [
      ...publicRoutes,
      { element: <RequireAuth />, children: protectedRoutes },
    ],
  },
];

export default routeConfig;
